import { Component } from '@angular/core';
import { LayoutMainComponent } from '../layout-main/layout-main.component';

@Component({
  selector: 'app-layout-sub-header',
  imports: [LayoutMainComponent],
  templateUrl: './layout-sub-header.component.html',
  styleUrl: './layout-sub-header.component.scss',
})
export class LayoutSubHeaderComponent {}
